import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { emptySplitApi } from '~/services/api/emptySplitApi';

import { playlistSlice } from './slices/playlistSlice';
import { searchSlice } from './slices/searchSlice';

const reducer = combineReducers({
  [emptySplitApi.reducerPath]: emptySplitApi.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [playlistSlice.name]: playlistSlice.reducer,
});

export const store = configureStore({
  reducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([emptySplitApi.middleware]),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
